module.exports = __webpack_public_path__ + "media/images/memes/mind-blown-dc3256f88a2e77c8929e78290a5dec09.gif";